// @flow

import styled from 'styled-components';
import { mr } from 'styled-components-spacing';

import theme from '@theme';

import { STRONG, MEDIUM, WEAK } from './constants';

const strengthColor = (strength) => {
  switch (strength) {
    case STRONG:
      return theme.colors.lightCyan;

    case MEDIUM:
      return theme.colors.warn;

    case WEAK:
      return theme.colors.error;

    default:
      return theme.colors.greyBlue10;
  }
};

export const StyledCover = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;

  min-height: 44px;
`;

export const StyledIndicator = styled.div`
  height: 8px;
  flex: 1;

  ${({ strength, isActive }) =>
    `background-color: ${isActive ? strengthColor(strength) : theme.colors.greyBlue10};`}

  &:not(:last-child) {
    ${mr(1)}
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledLabel = styled.span`
  display: block;
  flex: 1;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: ${theme.colors.white};
`;

export const StyledStrength = styled.span`
  display: block;
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  text-align: right;

  color: ${({ strength }) => strengthColor(strength)};
`;
